module.exports = __webpack_public_path__ + "img/trophy-fill.c235dfa9.svg";